import React, { useState, useEffect } from "react";
import "./Notes.css";
import plus from "../../assets/plus.svg";

const Notes = ({
  ticker,
  sessionAnnotations,
  setSessionAnnotations,
  noteDeletes,
  setNoteDeletes,
  actionHistory,
  setActionHistory,
}) => {
  const [notes, setNotes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newNote, setNewNote] = useState("");

  useEffect(() => {
    if (ticker) {
      if (sessionAnnotations[ticker]) {
        const sortedNotes = [...(sessionAnnotations[ticker].notes || [])]
          .map((note) => ({
            date: new Date(note.date),
            note: note.note,
          }))
          .sort((a, b) => b.date - a.date); // Sort latest first
        setNotes(sortedNotes);
      } else {
        setNotes([]);
      }
    }
  }, [ticker, sessionAnnotations]);

  const handleAddNote = () => {
    if (newNote.trim()) {
      const note = { date: new Date(), note: newNote };
      const existing = sessionAnnotations[ticker] || {
        hLines: [],
        cLines: [],
        vLines: [],
        circles: [],
        texts: [],
        notes: [],
      };
      const updated = {
        ...sessionAnnotations,
        [ticker]: {
          ...existing,
          notes: [...existing.notes, note],
        },
      };
      setSessionAnnotations(updated);
      const existingHistory = actionHistory[ticker] || [];
      setActionHistory({
        ...actionHistory,
        [ticker]: [...existingHistory, { type: "note", value: note }],
      });
      setNewNote("");
      setShowModal(false);
    }
  };

  const handleDeleteNote = (indexToDelete) => {
    const noteToDelete = notes[indexToDelete];
    const updatedNotes = notes.filter((_, i) => i !== indexToDelete);
    const updated = {
      ...sessionAnnotations,
      [ticker]: {
        ...sessionAnnotations[ticker],
        notes: updatedNotes,
      },
    };
    setSessionAnnotations(updated);
    const existingHistory = actionHistory[ticker] || [];
    const matchingIndex = existingHistory.findIndex(
      (entry) =>
        entry.type === "note" &&
        entry.value.note === noteToDelete.note &&
        new Date(entry.value.date).getTime() === noteToDelete.date.getTime()
    );

    if (matchingIndex !== -1) {
      const updatedHistory = [
        ...existingHistory.slice(0, matchingIndex),
        ...existingHistory.slice(matchingIndex + 1),
      ];
      setActionHistory({
        ...actionHistory,
        [ticker]: updatedHistory,
      });
    } else {
      setNoteDeletes(noteDeletes + 1);
    }
  };

  const handleCancel = () => {
    setNewNote("");
    setShowModal(false);
  };

  const formatDate = (date) =>
    date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  return (
    <div className="notes-container">
      <div className="note-list">
        {notes.map((note, index) => (
          <div key={index} className="note-row">
            <span className="note-date">{formatDate(note.date)}</span>
            <span className="note-text">{note.note}</span>
            <button
              className="note-delete"
              onClick={() => handleDeleteNote(index)}
            >
              Delete
            </button>
          </div>
        ))}
      </div>

      <button className="floating-btn" onClick={() => setShowModal(true)}>
        <img
          src={plus}
          alt="plus"
          height={18}
          width={18}
          style={{ marginLeft: "1.5px", marginBottom: "2.5px" }}
        />
      </button>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <div>Add a Note</div>
            <textarea
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              rows="5"
              maxLength={200}
              placeholder="Write your note here..."
            />
            <div className="cha-count">{newNote.length} / 200</div>
            <div className="modal-buttons">
              <button onClick={handleAddNote}>OK</button>
              <button onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notes;
